module.exports = __webpack_public_path__ + "img/delete_bucket.106eba27.svg";